import layout1Settings from "./Layout1/Layout1Settings";

export const GullLayoutSettings = {
  activeLayout: "layout1", // layout1, layout2
  dir: "ltr", // ltr, rtl
  layout1Settings,
  customizer: {
    show: true,
    open: true
  },
  footer: {
    show: true
  }
};
